module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-o"
  }), _vm._v("   " + _vm._s(_vm.nowDate) + "   ::  \n      "), _c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("   " + _vm._s(_vm.nowTime) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db3c6bda!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/public/components/clock.vue
// module id = 701
// module chunks = 0